<style lang="scss">
    @import '~@/assets/css/var';
    @include btn('blue', $main);
    @include btn('green', #44cb87);
    @include btn('red', #ff6b6b);

    @include btnSolid('blue', $main);
    @include btnSolid('green', #44cb87);
    @include btnSolid('red', #ff6b6b);

    @include btnText('blue', $main);
    @include btnText('red', #ff6b6b);
    @include btnText('green', #44cb87);

    .ellipsis {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
    }

    .table-page {
        overflow: hidden !important;
    }

    .el-header {
        display: flex;
        line-height: 50px;
        height: 50px;
        overflow: hidden;
        padding: 0;
        background: #fff;
        border-bottom: 1px solid $border;
        .el-dropdown {
            margin-left: 20px;
        }
        .close {
            width: 50px;
            line-height: 50px;
            margin-left: 10px;
            color: $red;
            cursor: pointer;
            text-align: center;
            font-size: 20px;
            &:hover {
                color: #fff;
                background: $red;
            }
        }
    }
    .el-aside {
        background: #fff !important;
    }
    .el-menu {
        border-top: 1px solid $lightBorder;
        border-right: 0;
        overflow: hidden auto;
        &::-webkit-scrollbar{
            display: none;
        }
        * {
            font-size: 12px;
        }

        .el-submenu__title {
            background: #fcfcfc;
        }
        .el-submenu__title, .el-menu-item {
            height: 45px;
            line-height: 45px;
            border-bottom: 1px solid $lightBorder !important;
        }

    }

    .stretch {
        &-child {
            font-size: 15px;
            transition: .1s width ease-in-out;
            &.el-aside {
                position: relative;
                display: flex;
                flex-direction: column;
                box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
            }
        }
        &-operate {
            float: left;
            width: 50px;
            line-height: 50px;
            text-align: center;
            cursor: pointer;
            font-size: 18px;
            color: $main;
            &:hover {
                background: $border;
            }
        }
    }

    .parent-tabs {
        margin-bottom: $intervalWidth;
        background: #fff;
        .el-tabs {
            &__nav-wrap {
                margin: 0;
            }
            &__header {
                margin: 0;
                border: 0;
                .el-tabs__nav {
                    border: 0;
                }
            }
            &__item {
                min-width: 60px;
                height: 34px;
                line-height: 34px;
                padding: 0 10px !important;
                text-align: center;
                font-size: 11px;
                color: #999;
                border-left: 0 !important;
                border-right: 0 !important;
                &.is-active {
                    color: #555;
                    background: #f2f2f2;
                    border-bottom: 2px solid $main !important;
                }
            }
        }
    }

    .parent-panel {
        flex: 1;
        position: relative;
        z-index: 2;

        > div {
            position: absolute;
            display: flex;
            flex-direction: column;
            flex-wrap: nowrap;
            padding: $intervalWidth 25px;
            flex: 1;
            opacity: 0;
            top: 0;
            left: $intervalWidth;
            right: $intervalWidth;
            bottom: $intervalWidth;
            transition: all 0.3s;
            height: 0;
            overflow: hidden auto;
            background: #fff;
        }

        .active {
            opacity: 1;
            z-index: 1;
            height: auto;
        }
    }
    .close-tab {
        position: fixed;
        text-align: center;
        z-index: 999;
        top: 50%;
        left: 50%;
        background: #fff;
        color: #333;
        font-weight: 700;
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
        border-radius: 3px;
        overflow: hidden;

        & > div {
            height: 35px;
            padding: 0 10px;
            line-height: 35px;
            cursor: pointer;

            &:hover {
                background-color: $main;
                color: #fff;
            }
        }
    }
    .table-page {
        overflow: hidden;
    }
    .user-info {
        padding: 15px 0;
        text-align: center;
        .corp {
            font-weight: bold;
        }
        img {
            width: 50px;
            margin: 15px 0;
        }
        .name {
            font-size: 12px;
        }
    }
</style>
<template>
    <el-container>

        <el-aside class="stretch-child" :width="collapse ? '65px' : '200px'" style="background-color: rgb(238, 241, 246)">
            <div class="user-info">
                <p class="corp">{{$store.state.userInfo.manageSubjectName}}</p>
                <img src="//platform-data.jundaodsj.com/FvLWNXb74hScW0k_9Sz4FIJ67qAZ" alt>
                <p class="name">{{$store.state.userInfo.userName}}</p>
            </div>
            <el-menu :default-active="editableTabsValue" @select="goPageComponent" unique-opened :collapse="collapse">
                <el-submenu v-for="item in menu" :key="item.id" :index="item.requestPath">
                    <template slot="title">
                        <i :class="item.iconUrl"></i>
                        <span slot="title">{{item.menuName}}</span>
                    </template>
                    <el-menu-item v-for="child in item.children" :key="`${item.requestPath}-${child.requestPath}`"
                                  :index="`${item.requestPath}_${child.requestPath}-${child.menuName}`">{{child.menuName}}</el-menu-item>
                </el-submenu>
            </el-menu>
        </el-aside>
        <el-container>
            <el-header height="50">
                <i class="stretch-operate" :class="collapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'" @click="collapse = !collapse"></i>
                <div class="flex stretch-child" style="float: left;">
                    <span style="font-weight: bold;">君道CMS管理平台</span>
                </div>
                <div class="flex-item"></div>
                <el-dropdown size="medium"  @command="userChange">
                <span class="el-dropdown-link">
                {{$store.state.userInfo.userName}}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                    <el-dropdown-menu class="dropdown-size" slot="dropdown">
                        <el-dropdown-item class="show" icon="el-icon-warning" command="update">修改密码</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>

                <div class="close" @click="quit">
                    <i class="el-icon-switch-button"></i>
                </div>
            </el-header>
            <el-container class="stretch-child" direction="vertical">
                <el-tabs class="parent-tabs" v-model="editableTabsValue" type="card" @tab-remove="removeTab">
                    <el-tab-pane v-for="(item, index) in editableTabs" :key="item.name + index" :label="item.title"
                                 :name="item.name + '-' + item.title" :closable="index !== 0">
                        <template #label v-if="item.name === 'index'">
                            <i style="font-size: 14px;margin-right: 7px;" class="el-icon-house"></i><span style="margin-right: 5px;">首页</span>
                        </template>
                    </el-tab-pane>
                </el-tabs>
                <el-main class="parent-panel">
                    <template v-for="item in pathConfig">
                        <component :key="item.key" :is="item.component" :ref="item.key"
                                   v-if="isShowTab(item.key)" :class="{ active:isMe(item.key) }"></component>
                    </template>
                </el-main>
            </el-container>
        </el-container>


        <transition name="el-zoom-in-top">
            <div class="close-tab" ref="closeTab" v-show="isRight">
                <div @click="closeBesideSelf">除此之外全部关闭</div>
                <div @click="closeAll">关闭全部标签</div>
            </div>
        </transition>

        <!--region 公共的confirm-->
        <my-dialog :show.sync="$store.state.alertInfo.show" width="400px"
                   :title="$store.state.alertInfo.title" :hideCancel="$store.state.alertInfo.hideCancel"
                   @save="saveConfirm" :loading="$store.state.alertInfo.loading">
            <div class="flex">
                <!--<i class="icon info el-icon-info"></i>-->
                <div class="ls-dialog__msg">{{$store.state.alertInfo.content}}</div>
            </div>
        </my-dialog>
        <!--endregion-->

        <!--修改密码弹窗-->
        <my-dialog :show.sync="updatePwd.show" width="400px" title="修改密码" :loading="updatePwd.loading" @save="updatePwdSave">
            <el-form label-width="100px">
                <el-form-item label="原密码" required>
                    <el-input v-model="updatePwd.form.oldPassword" type="password"></el-input>
                </el-form-item>
                <el-form-item label="新密码" required>
                    <el-input v-model="updatePwd.form.password" type="password"></el-input>
                </el-form-item>
                <el-form-item label="确认密码" required>
                    <el-input v-model="updatePwd.form.confirmPassword" type="password"></el-input>
                </el-form-item>
            </el-form>
        </my-dialog>

        <!--强制修改密码-->
        <el-dialog title="提示" :visible.sync="forcePwd.show" :show-close="false" :close-on-click-modal="false">
            <p style="padding-bottom: 25px;font-size: 16px;">检测到您首次登陆系统，请修改密码</p>
            <el-form label-width="100px">
                <el-form-item label="原密码" required>
                    <el-input v-model="forcePwd.pwd" type="password"></el-input>
                </el-form-item>
                <el-form-item label="新密码" required>
                    <el-input v-model="forcePwd.newPwd" type="password"></el-input>
                </el-form-item>
                <el-form-item label="确认密码" required>
                    <el-input v-model="forcePwd.rePwd" type="password"></el-input>
                </el-form-item>
            </el-form>

            <span slot="footer">
                <el-button type="primary" @click="forceSave" :loading="forcePwd.loading">确 定</el-button>
            </span>
        </el-dialog>
    </el-container>
</template>

<script>
    import help from '@/util/help';
    import variable from '@/util/variable';

    function loadComponent(url) {
        return () => import(`@/pages/${url}`)
    }

    export default {
        data() {
            return {
                collapse: false,
                manageSubjectName:'',
                userName:'',
                // region 左菜单相关参数
                menu: [],
                editableTabsValue: '',
                editableTabs: [],
                pathConfig: {},
                // endregion

                // region 右键删除菜单的相关参数
                deleteKey: '',
                isRight: false,
                // endregion

                updatePwd: {
                    show: false,
                    loading: false,
                    form: {
                        confirmPassword: '',
                        oldPassword: '',
                        password: ''
                    },
                },

                forcePwd: {
                    show: false,
                    loading: false,
                    pwd: '',
                    newPwd: '',
                    rePwd: '',
                },
            }
        },
        mounted() {
            if (this.$help.tokenHelp.get()) {
                this.$store.dispatch('setUser')
                this.configPath()

            } else {
                this.$help.tokenHelp.remove()
                this.$store.commit('setPage', this.$variable.pageType.LOGIN)
            }
            help.goPage = this.goPage;

            const self = this
            document.querySelector('.el-tabs__nav').oncontextmenu = e => {
                self.deleteKey = e.target.id.split('-')[1]
                let x = e.clientX
                let y = e.clientY
                self.$refs.closeTab.style.left = x + 'px'
                self.$refs.closeTab.style.top = y + 'px'
                self.isRight = true
                e.preventDefault()
            }
            document.body.addEventListener('click', () => self.isRight = false)


            // 关闭tab
            window.closeCurrentTab = this.removeTab
        },
        methods: {
            configPath() {
                let pathConfig = {
                    // 首页
                    index: {
                        key: 'index',
                        value: '首页',
                        component: loadComponent('home'),
                    },

                    // 'test2_test3': {
                    //     key: 'test2_test3',
                    //     value: '测试',
                    //     component: loadComponent('test2/test3')
                    // },
                }

                // 设置菜单权限
                let obj = {};

                this.$api.post('sys/menu/getMenuListByUser').then(res => {
                    // res.push({
                    //     id: 12312,
                    //     menuName: '测试',
                    //     requestPath: 'test2',
                    //     children: [
                    //         {
                    //             id: 1231112,
                    //             menuName: '测试2',
                    //             requestPath: 'test3',
                    //         }
                    //     ]
                    // })
                    this.menu = res;
                    this.menu.forEach(parent => {
                        parent.children && parent.children.forEach(child => {
                            // 列表页面
                            pathConfig[`${parent.requestPath}_${child.requestPath}`] = {
                                key: `${parent.requestPath}_${child.requestPath}`,
                                value: child.menuName,
                                component: loadComponent(`${parent.requestPath}/${child.requestPath}`)
                            }

                            child.children && child.children.forEach(item => {
                                obj[item.id] = item.menuName;
                            })
                        })
                    })
                    this.$store.commit('setBtnRights', obj);
                    this.pathConfig = pathConfig;
                    // 默认加载首页
                    this.editableTabsValue = this.pathConfig.index.key
                    this.addTab(this.pathConfig.index)
                })
            },

            // region 顶部页面标签相关方法
            removeTab(targetName) {
                targetName = targetName || this.editableTabsValue
                let tabs = this.editableTabs
                let activeName = this.editableTabsValue
                if (activeName === targetName) {
                    tabs.forEach((tab, index) => {
                        if (this.compareComponent(tab.name, targetName)) {
                            let nextTab = tabs[index + 1] || tabs[index - 1]
                            if (nextTab) {
                                activeName = nextTab.name + '-' + nextTab.title
                            }
                        }
                    })
                }
                this.editableTabsValue = activeName
                this.editableTabs = tabs.filter(
                    tab => !this.compareComponent(tab.name, targetName)
                )
            },
            addTab(to) {
                let isExit = false
                for (let i = 0; i < this.editableTabs.length; i += 1) {
                    if (this.editableTabs[i].name === to.key) {
                        isExit = true
                        break
                    }
                }
                if (!isExit) {
                    this.editableTabs.push({
                        name: to.key,
                        title: to.value
                    })
                }

                this.editableTabsValue = to.key + '-' + to.value
            },
            goPage(index, title) {
                const param = index.split('-')
                const data = this.pathConfig[param[0]]
                this.pathConfig[param[0]].value = title ? title : param[1]
                if (data) {
                    this.addTab(data)
                }
            },
            goPageComponent(index) {
                this.goPage(index)
            },
            isShowTab(currentKey) {
                for (let i = 0; i < this.editableTabs.length; i += 1) {
                    if (this.editableTabs[i].name === currentKey) {
                        return true
                    }
                }
                return false
            },
            isMe(key) {
                return this.compareComponent(key, this.editableTabsValue)
            },
            compareComponent(key, current) {
                return key === current.split('-')[0]
            },
            // endregion

            // region 右键菜单方法
            closeBesideSelf() {
                this.editableTabs.forEach(item => {
                    if (item.name !== 'index' && item.name !== this.deleteKey) {
                        this.removeTab((`${item.name}-${item.title}`))
                    }
                })
            },
            closeAll() {
                this.editableTabs.forEach(item => {
                    if (item.name !== 'index') {
                        this.removeTab((`${item.name}-${item.title}`))
                    }
                })
            },
            // endregion

            // region 公共confirm相关方法
            saveConfirm() {
                this.$store.state.alertInfo.loading = true
                this.$store.state.alertInfo.callback(this.closeConfirm, () => {
                    this.$store.state.alertInfo.loading = false
                })
            },
            closeConfirm() {
                this.$store.state.alertInfo.show = false
                this.$store.state.alertInfo.loading = false
            },
            // endregion

            updatePwdShow() {
                this.updatePwd.show = true;
                this.updatePwd.loading = false;
                this.updatePwd.form = {};
            },
            updatePwdSave() {
                if (!this.updatePwd.form.oldPassword) {
                    help.error('请输入原密码');
                    return
                }
                if (!this.updatePwd.form.password) {
                    help.error('请输入新密码');
                    return
                }
                if (this.updatePwd.form.password !== this.updatePwd.form.confirmPassword) {
                    help.error('两次密码不一致');
                    return
                }
                this.updatePwd.loading = true;
                this.$api.post('sys/login/updatePwd', this.updatePwd.form)
                    .then(res => {
                        help.success(res.msg);
                        this.updatePwd.show = false;
                    })
                    .finally(() => {
                        this.updatePwd.loading = false;
                    })
            },

            // 强制修改密码
            forceSave() {
                if (!this.forcePwd.pwd) {
                    help.error('请输入原密码');
                    return
                }
                if (!this.forcePwd.newPwd) {
                    help.error('请输入新密码');
                    return
                }
                if (this.forcePwd.newPwd !== this.forcePwd.rePwd) {
                    help.error('两次密码不一致');
                    return
                }
                this.forcePwd.loading = true;
                this.$api.post('sysUser/updatePassword', variable.gateway.uc, {
                    confirmPassword: this.forcePwd.rePwd,
                    oldPassword: this.forcePwd.pwd,
                    password: this.forcePwd.newPwd
                })
                    .then(res => {
                        help.success(res.msg);
                        this.forcePwd.show = false;
                    })
                    .finally(() => {
                        this.forcePwd.loading = false;
                    })
            },
            userChange(command) {
                if (command === 'update') {
                    this.updatePwdShow();
                }
            },
            quit() {
                this.$store.commit('confirm', {
                    content: '确定退出吗',
                    callback: next => {
                        this.$store.commit('setPage', variable.pageType.LOGIN);
                        this.$help.tokenHelp.remove();
                        this.$help.success('退出成功')
                        next();
                    }
                })
            },
        }
    }
</script>


<style lang="scss">
    .flex-body {
        .el-drawer__body {
            display: flex;
            flex-direction: column;
        }
    }

    .chart-panel {

    }
</style>